import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSScansched = {
    name: 'VS Schedule a Scan',
    imageUrl: '../../images/VSScansched.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSAgent = {
    name: 'VS Select Agent',
    imageUrl: '../../images/VSAgent.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIVSTarget = {
    name: 'VS Select Target',
    imageUrl: '../../images/VSTarget.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIVSSubmit = {
    name: 'VS Select Target',
    imageUrl: '../../images/VSSubmit.png',
    imageSize: "90%",
    bradius: 20,
  };


export const VSSched = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Schedule a Scan</b><br/><br/>
      In this section, vulnerability scans may be created, configured, and scheduled. <br/><br/>
      To create a new vulnerability scan: <br/><br/>
      <b>Assign a scan name </b><br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>This should be specific and unique to this scan (or, if scheduling or repeating a scan, use a name for this series of scans) </li></ul><br/><br/>
      <b>Select Scan Type</b><br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Select which type of vulnerability scan to perform: internal or external </li><br/>
      <li>Select if this scan is to run authenticated or unauthenticated </li><br/>
      <li>Authenticated scans use the agent credentials (or scan credentials – if supplied) to connect to each target and scan </li><br/>
      <li>In an unauthorized scan, the agent will have no authority and will only scan devices and hosts from a network perspective </li></ul><br/>
      <b>Set the scan schedule </b><br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Run Now - As soon as the agent has availability </li><br/>
      <li>One-time - Pick a future time and date for the scan to run </li><br/>
      <li>Recurring - Select your recurrence schedule.</li></ul><br/>
      <b>Set notification preference</b><br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Should an email notification be needed upon scan completion, then select yes. The drop-down list of recipients 
      includes users that have been set up by the Command Center Administrator under ADMIN -&gt; Users section.  </li></ul><br/>
      <b>Set the Offline Delay</b><br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>If group scan was selected, the offline delay value can be adjusted using the dropdown. The offline delay specifies 
      the number of hours that the overall scan may wait for agents that are included in the scan but offline, to return to 
      being online. Once the offline delay time expires, the scan completes, and any specific agents that were still offline 
      are marked as incomplete in the scan results. </li></ul>

      </div>
      <div style={helpimg}>
      <img
        src={UIVSScansched.imageUrl}
        alt={'Image of ' + UIVSScansched.name}
        style={{
          width: UIVSScansched.imageSize,
          borderRadius: UIVSScansched.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const VSAgent = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Select an Agent</b><br/><br/>
      Select the agent to perform the vulnerability scan with. The agent selected should be the one that is on the same 
      network segment as the scan targets to ensure the agent has access to the targets or networks <br/><br/>
      Please note the following information: <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>There are two reserved agents available. These are external and remote_group </li><br/>
      <li>External – only appears when performing an external scan. An external scan allows scans of a network 
      from the outside to test the network perimeter </li><br/>
      <li>Remote_Group – this is not an actual agent, but rather the means to select a group of targets that also host 
      agents so that the agents can be grouped into a single scan with a single set of results and associated mitigation plans </li><br/>
      <li>To install a CyBroker agent in a portion of your network that contains the data you want to scan, 
      please click ADMIN&gt;Scan Agents within the top navigation bar of the page. For further assistance on how to 
      install a CyBroker agent, simply refer to the help section within the scan agents section </li></ul><br/>
      After selecting an Agent, click on Select Targets or go to Next Step to see a list of associated Targets/Devices 
      and select the ones you would like to scan.  
      </div>
      <div style={helpimg}>
      <img
        src={UIVSAgent.imageUrl}
        alt={'Image of ' + UIVSAgent.name}
        style={{
          width: UIVSAgent.imageSize,
          borderRadius: UIVSAgent.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const VSTarget = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Select Targets</b><br/><br/>
      Each target that is stored within the Command Center Database is listed along with its associated IP 
      address and vulnerability profile. It’s generally best to select targets that are in the same network 
      subnet as the agent host. Targets in other network segments can be included; however, there must be 
      permissions within the network to ensure the agent host has access to the targets within that subnet. 
      Please note that scanning targets in distant subnets can produce slower results. <br/><br/>
      <b>Select credentials</b> <br/><br/>
      In addition to selecting your targets, you will also be required to select which credential you would 
      like to use for this particular scan. You have the choice of the following options: <br/><br/>
      <b>Use Default</b> - If the default option is selected, this will use the credential that has been previously 
      assigned to this agent during the agent setup. <br/><br/>
      <b>Use Alternative</b> - Should the agent require a different credential to access the target data to be 
      scanned, select the <b>use alternative</b> option and then supply those pre-existing credentials to the agent 
      to perform the task. Be sure to include the NetBIOS domain name in the domain field. If the agent is a 
      standalone agent (not on a domain), enter the agent's NetBIOS name in place of the domain. <br/><br/>
      Click the <b>Review Scan</b> button to be directed to a confirmation page to review scan details in full. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSTarget.imageUrl}
        alt={'Image of ' + UIVSTarget.name}
        style={{
          width: UIVSTarget.imageSize,
          borderRadius: UIVSTarget.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const VSSubmit = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Review Scan Details</b><br/><br/>
      Review the scan settings, and if no changes or further edits are required, click Submit Scan. 
      If changes are needed, click Edit and then modify the scan accordingly. Once the required changes 
      have been made, submit the scan and complete the overall process. <br/><br/>
      Typically, a vulnerability scan will take approximately 10 – 15 minutes to run per Target. 

      </div>
      <div style={helpimg}>
      <img
        src={UIVSSubmit.imageUrl}
        alt={'Image of ' + UIVSSubmit.name}
        style={{
          width: UIVSSubmit.imageSize,
          borderRadius: UIVSSubmit.bradius,
        }}
      />
      </div>
    </div>
  );
};